var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowArrowRightOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 26,
    viewBox: "0 0 11 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 13L0.599975 25.5L0.599975 0.5L10.6 13Z",
    fill: "#50A0FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowArrowRightOn);
export default __webpack_public_path__ + "static/media/flow_arrow_right_on.d61a3913b17287fa76522032e7062163.svg";
export { ForwardRef as ReactComponent };